import Viewer from './Viewer.vue'
export default Viewer
